module.exports = __webpack_public_path__ + "7d4d94d4b39421eecf88ceadf2f00a84.svg";